module.exports = __webpack_public_path__ + "static/assets/b3194e4bba87be45fbc83d3029fc7926.png";